import styled from 'styled-components';

export const UamRegistrationPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  h2 {
    font-size: 1.125rem !important;
  }
`;

export const UamErrorTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const UamErrorText = styled.p`
  color: #E0205D;
  font-size: 0.875rem;
  text-align: center;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  margin-bottom: 1.5rem;
`;
